export default __webpack_public_path__ + "static/media/dao.4d80dbb8.png";